import { render, staticRenderFns } from "./license.vue?vue&type=template&id=55ee2cda&"
import script from "./license.vue?vue&type=script&lang=ts&"
export * from "./license.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports